<template>
	<v-card>
		<v-card-title>
			<h2>Niepotwierdzeni użytkownicy</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<unregistered-users-table></unregistered-users-table>
	</v-card>
</template>

<script>
	import UnregisteredUsersTable from "./components/UnconfirmedUsersTable";

	export default {
		name: "UnregisteredUsersView",
		components: {UnregisteredUsersTable},
	};
</script>

<style scoped>

</style>
